import {useMemo} from 'react';
import {FeedbackController} from '../feedback-controller';
import {FeedbackRequestImpl} from '../feedback-requests';
import {useState} from 'react';
import {toInclusiveFeedbackEndDate} from '../feedback-date.utils';
import {allTimeFeedbackRange} from '../feedback-date-range';

export const useMyFeedbackHook = () => {
  const [theme, setTheme] = useState('');

  const [sortBy, setSortBy] = useState('desc');

  const [selectedUser, setSelectedUser] = useState('');

  const [dateRange, setDateRange] = useState(allTimeFeedbackRange);

  const request = useMemo(() => new FeedbackRequestImpl(), []);

  const controller = useMemo(() => new FeedbackController(request), [request]);

  const filters = useMemo(() => {
    return {
      paginate: false,
      startDate: dateRange.starts || undefined,
      endDate: dateRange.ends
        ? toInclusiveFeedbackEndDate(dateRange.ends)
        : undefined,
      sortBy: `createdAt:${sortBy}`,
      impression: theme,
      reviewer: selectedUser || undefined,
    };
  }, [dateRange.starts, dateRange.ends, theme, sortBy, selectedUser]);

  return {
    controller,
    filters,
    sortBy,
    selectedUser,
    setSelectedUser,
    setSortBy,
    dateRange,
    setDateRange,
    theme,
    setTheme,
  };
};
